import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { getSettings } from "../api/client";

const Layout = ({ children, settings, lang, setLang, theme, setTheme }) => {
    return (
        <div className={lang === "ar" ? "rtl" : ""}>
            <Navbar settings={settings} lang={lang} setLang={setLang} theme={theme} setTheme={setTheme} />
            <main>
                {children}
            </main>
            <Footer settings={settings} lang={lang} />
        </div>
    );
};

export default Layout;
